<template>
  <v-container>
    <v-row>
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <list-list show-owners :lists="lists">
          <template #footer>
            <v-card v-if="adding" flat width="100%" :loading="addingLoading">
              <v-card-text>
                <v-text-field
                  v-model="title"
                  outlined
                  placeholder="list title"
                />
                <v-textarea
                  v-model="description"
                  outlined
                  placeholder="description"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="adding = false">Cancel</v-btn>
                <v-btn
                  text
                  color="success"
                  :disabled="!title"
                  :loading="addingLoading"
                  @click="submitAdd"
                >Submit</v-btn>
              </v-card-actions>
            </v-card>
            <v-btn v-else text width="100%" @click="adding = true">Add</v-btn>
          </template>
        </list-list>
      </v-col>
      <v-col cols="3"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListList from "@/components/lists/ListList"

export default {
  name: "Lists",
  components: {
    ListList,
  },
  data() {
    return {
      lists: [],
      adding: false,
      addingLoading: false,
      title: "",
      description: "",
      archiveLoading: false,
    }
  },
  inject: ["httpClient"],
  computed: {
    me() {
      return this.$store.state.me
    },
  },
  methods: {
    async submitAdd() {
      this.addingLoading = true
      // TODO validate?
      const data = await this.httpClient.addList({
        title: this.title,
        description: this.description,
      })
      this.lists.splice(0, 0, data)
      this.addingLoading = false
      this.adding = false
      // TODO: better way than setTimeout?
      setTimeout(() => window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      }), 0)
    },
  },
  async mounted() {
    this.lists = await this.httpClient.loadAllLists()
  },
}
</script>
